import { breadcrumbsConfig, component, mergeConfig } from '@salutejs/plasma-new-hope/css';

import { config } from './Breadcrumbs.config';

const mergedConfig = mergeConfig(breadcrumbsConfig, config);
const BreadcrumbsComponent = component(mergedConfig);

/**
 * Breadcrumbs
 */
export const Breadcrumbs = BreadcrumbsComponent;
